import React, { useEffect, useState } from "react";
import "../Dashboard.css";
import "../Components/SideMenu.css";
import SideMenu from "../Components/SideMenu";
import "mdb-ui-kit/css/mdb.min.css";
import AddActivityTypeForm from "./AddActivityTypeForm";

import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { red } from "@mui/material/colors";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import Modal from "@mui/material/Modal";
import CircularIndeterminate from "../../GeneralComponents/CirularProgress";
import StyledDataGrid from "../../GeneralComponents/StyledDataGrid";
import "../../../../assets/css/DG.css";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";

import { useGlobalContext } from "../../../../context";
import UpdateActivityForm from "./Activities/UpdateActivityForm";
import ViewActivity from "./Activities/ViewActivity";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
};

export default function AddActivityType(props) {
  const [inactive, setInactive] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setpageNumber] = useState(1);
  const [activityTotal, setActivityTotal] = useState(0);
  const [activityNumberOfPages, setActivityNumberOfPages] = useState(0);
  const [showBoxOfEditForm, setshowBoxOfEditForm] = useState(false);
  const [showBoxOfViewForm, setshowBoxOfViewForm] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);
  const { loading, activities, fetchData } = useGlobalContext();

  const [columns] = useState([
    { field: "id", headerName: "ت", flex: 0.1 },

    {
      field: "groups_carriers",
      headerName: "المهنة",
      flex: 1,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.carrier?.groups_carriers?.name}
          </div>
        );
      },
    },
    {
      field: "carrier",
      headerName: "اسم النشاط",
      flex: 1,
      renderCell: (rows) => {
        return <div style={{ width: "100%" }}>{rows?.row?.carrier?.name}</div>;
      },
    },
    {
      field: "varieties_carrier",
      headerName: "الصنف",
      flex: 1,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.varieties_carrier?.name}
          </div>
        );
      },
    },
    {
      field: "calculation_type",
      headerName: "نوع الحساب",
      flex: 1,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>{rows?.row?.calculate_type?.type}</div>
        );
      },
    },
    {
      field: "amount",
      headerName: "القيمة",
      flex: 1,
      renderCell: (rows) => {
        return <div style={{ width: "100%" }}>{rows?.row?.amount}</div>;
      },
    },

    {
      field: "actions",
      flex: 1,
      headerName: "الادوات",
      renderCell: (rows) => (
        <strong>
          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="عرض"
            size="small"
            onClick={() => {
              viewObject(rows?.row);
            }}
          >
            <Tooltip title="View">
              <RemoveRedEyeRoundedIcon color="primary" />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="تعديل"
            size="small"
            onClick={() => {
              updateObject(rows.row);
            }}
          >
            <Tooltip title="Edit">
              <ModeEditOutlineRoundedIcon style={{ fill: "#deb12c" }} />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 20 }}
            aria-label="مسح"
            size="small"
            onClick={() => {
              //TODO delete object
            }}
          >
            <Tooltip title="Delete">
              <DeleteRoundedIcon sx={{ color: red[500] }} />
            </Tooltip>
          </IconButton>
        </strong>
      ),
    },
  ]);

  const [rows, setRow] = useState([]);
  const handlePageChange = (newPage) => {
    setpageNumber(newPage + 1);
  };

  const updateObject = async (object) => {
    setSelectedObject(object);

    setshowBoxOfEditForm(true);
  };
  const viewObject = async (object) => {
    setSelectedObject(object);
    setshowBoxOfViewForm(true);
  };
  const advanceSearch = () => {
    fetchData("ACTIVITIES", "activities", {
      page: pageNumber,
      page_size: pageSize,
    });
  };
  useEffect(() => {
    advanceSearch();
  }, [pageSize, pageNumber]);
  //Reformatting activity object once activity are loaded
  useEffect(() => {
    if (activities && activities.data && activities.data.length > 0) {
      setRow(activities.data);
      setActivityTotal(activities.total);
      setActivityNumberOfPages(activities.last_page);
    }
  }, [activities]);



  return (
    <div className="Dashboard_MOF px-0 mx-0">
      <div className="container-fluid w-100 mx-0 px-0">
        <div className="row rowContainer mx-0">
          <div className="col-md-12 col-xl-12 w-100 d-flex flex-column justify-content-center align-items-end  paddingForm">
            <AddActivityTypeForm inactive={props.inactive} /> 
            <div
              className={`FormContainer  ${
                props.inactive === false ? "activeSideMenu" : ""
              }`}
              style={{
                height: "calc(100% - 9em)",
                minHeight: 600,
                borderRadius: 10,
              }}
            >
              <StyledDataGrid
                rows={rows}
                columns={columns}
                rowCount={activities?.total ? activities?.total : 0}
                pageSize={pageSize}
                page={pageNumber - 1}
                onPageSizeChange={(newPageSize) => {
                  setPageSize(newPageSize);
                }}
                components={{
                  Footer: () => null,
                }}
                rowsPerPageOptions={[5, 10, 20]}
                // pagination
                paginationMode="server"
                onPageChange={(params) => {
                  handlePageChange(params);
                }}
              />
              <Box width="45%" m="auto" sx={{ marginTop: "10px" }}>
                <Pagination
                  color="primary"
                  size="large"
                  count={activityNumberOfPages}
                  page={pageNumber}
                  showFirstButton
                  showLastButton
                  onChange={(e, p) => {
                    setpageNumber(p);
                  }}
                />
              </Box>

              <div
                style={{
                  width: "50%",
                  position: "absolute",
                  top: "100px",
                  margin: "0 auto",
                  left: "50%",
                  top: "50%",
                }}
              >
                {loading && <CircularIndeterminate />}
              </div>
            </div>
          </div>

          {/* <SideMenu inactive={inactive} setInactiveFromProps={setInactive} /> */}
        </div>
      </div>

      <Modal
        keepMounted
        open={showBoxOfEditForm || showBoxOfViewForm}
        onClose={() => {
          setshowBoxOfEditForm(false);
          setshowBoxOfViewForm(false);
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            border: "none",
            outline: "none",
            borderRadius: "10px",
            overflow: "scroll",
          }}
          className="modalCroupsCarrier"
        >
          {selectedObject && showBoxOfEditForm && (
            <UpdateActivityForm object={selectedObject} />
          )}
          {selectedObject && showBoxOfViewForm && (
            <ViewActivity object={selectedObject} />
          )}
        </Box>
      </Modal>
    </div>
  );
}
